import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import SignUpPage from './pages/SignUpPage';
import Home from './pages/Home';
import CompanyDetails from './pages/CompanyDetails';
import CreateCompany from './components/CreateCompany';
import FileForm from './pages/FileForm';
import VehiclesTax from './pages/VehiclesTax';
import IrsPaymentOptions from './pages/IrsPaymentOptions';
import FormSummary from './pages/FormSummary';
import EditCompany from './pages/EditCompany';
import FileMonth from './pages/FileMonth';
import VehiclesTax8849 from './pages/VehicleTax8849';
import IrsPaymentOptions8849 from './pages/IrsPaymentOptions8849';
import FormSummary8849 from './pages/FormSummary8849';
import Profile from './pages/Profile';
import PaymentAndSubmission from './pages/PaymentAndSubmission';
import IrsConfirmation from './pages/IrsConfirmation';
import ForgotPassword from './pages/ForgotPassword';
import Header from './pages/Header'; // ⬅ обязательно импортируем Header
import ResetPassword from './pages/ResetPassword';
import Pricing from './pages/Pricing';
import DueDates from './pages/DueDates';
import ContactUs from './pages/ContactUs';
import BeginAmendedReturn from './pages/BeginAmendedReturn';
import ChangeVehicleCategory from './pages/ChangeVehicleCategory';
import AmendedPaymentAndSubmission from './pages/AmendedPayment';
import AmendedIrsConfirmation from './pages/AmendedIrsConfimation';
import AdminDashboard from './pages/AdminDashboard';
import RequireStaff from './components/RequireStaff';
import IrsStatusBanner from './components/IrsStatusBanner';
import AckDetails from './pages/AckDetails';
import ChangeVehicleVIN from './pages/ChangeVehicleVIN';
import ChangeVehicleSuspension from './pages/ChangeVehicleSuspension';
import ChangeVehicleMileage from './pages/ChangeVehicleMileage';
function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    fetch('/api/users-logic/me/', {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        if (res.ok) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
          localStorage.removeItem('token');
        }
      })
      .catch(() => {
        setIsAuthenticated(false);
        localStorage.removeItem('token');
      });
  }, []);

  return (
    <Router>
      {/* Баннер аварийной паузы: показывается сам, если сервер сообщил о паузе */}
      <IrsStatusBanner />
      <Routes>
        <Route path="/sign-in" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
        <Route path="/sign-up" element={<SignUpPage setIsAuthenticated={setIsAuthenticated}  />} />
        <Route path="/" element={<Home isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />} />
        <Route path="/pricing" element={<Pricing isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />} />
        <Route path="/due-dates" element={<DueDates isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />}/>
        <Route path="/contact" element={<ContactUs isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}/>}/>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/create-company" element={<CreateCompany />} />
        <Route path="/company/:id" element={<CompanyDetails />} />
        <Route path="/company/:id/edit" element={<EditCompany />} />
        <Route path="/company/:id/file-form" element={<FileForm />} />
        <Route path="/company/:id/file-form/vehicles-tax" element={<VehiclesTax />} />
        <Route path="/company/:id/file-form/vehicles-tax-8849" element={<VehiclesTax8849 />} />
        <Route path="/company/:id/file-form/irs-payment-options" element={<IrsPaymentOptions />} />
        <Route path="/company/:id/file-form/irs-payment-options-8849" element={<IrsPaymentOptions8849 />} />
        <Route path="/company/:id/file-form/form-summary" element={<FormSummary />} />
        <Route path="/company/:id/file-form/form-summary-8849" element={<FormSummary8849 />} />
        <Route path="/company/:id/file-form/file-month" element={<FileMonth />} />
        <Route path="/company/:id/payment-and-submission" element={<PaymentAndSubmission />} />
        <Route path="/company/:id/amended-payment-and-submission" element={<AmendedPaymentAndSubmission />} />
        <Route path="/company/:id/file-form/irs-confirmation" element={<IrsConfirmation />} />
        <Route path="/company/:id/amended-return/irs-confirmation" element={<AmendedIrsConfirmation />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/company/:id/begin-amended" element={<BeginAmendedReturn />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/company/:id/file-form/change-vehicle-category" element={<ChangeVehicleCategory />} />
        <Route path="/company/:id/file-form/change-vin" element={<ChangeVehicleVIN />} />
        <Route path="/company/:id/file-form/change-suspension" element={<ChangeVehicleSuspension />} />
        <Route path="/company/:id/file-form/change-mileage" element={<ChangeVehicleMileage />} />
        <Route path="/user" element={<Profile />} />
        <Route
          path="/company/:id/forms/:formId/ack/:submissionId"
          element={<AckDetails />}
        /> 
        <Route
          path="/admin"
          element={
            <RequireStaff>
              <AdminDashboard />
            </RequireStaff>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
